import { Box, makeStyles } from "@material-ui/core";
import * as React from "react";
import { Filter, ListBase, Pagination, ReferenceInput, SelectInput, TextInput } from "react-admin";
import GridList from "./GridList";

const useStyles = makeStyles((theme) => ({
  root: {
    transform: "translateZ(0)",
    margin: 0,
    boxSizing: "border-box",
    padding: "0 10px 0 10px",
    justifyContent: "left",
    width: "100%",
  },
}));

export const SearchVideoFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Title" source="title__contains" alwaysOn />
    <ReferenceInput label="Category" source="categoryId__eq" reference="categorys" alwaysOn sort={{ field: "name", order: "ASC" }}>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      label="Chapter"
      source="videochapters.any(x => x.TraxChapterId == $)"
      reference="traxchapters"
      sort={{ field: "chapter", order: "ASC" }}
      perPage={500}
      alwaysOn
    >
      <SelectInput optionText={(choice) => `${choice.chapter} - ${choice.description}`} optionValue="chapter" />
    </ReferenceInput>
  </Filter>
);

const SearchVideoList = (props) => {
  return (
    <ListBase {...props} perPage={20} sort={{ field: "id", order: "DESC" }} filter={{ status__eq: "3" }}>
      <SearchVideoListView />
    </ListBase>
  );
};

const SearchVideoListView = () => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.root}>
        <h3>Search</h3>
        <SearchVideoFilter />
        <GridList />
        <Pagination rowsPerPageOptions={[10, 20]} />
      </Box>
    </>
  );
};

export default SearchVideoList;
